module.exports = __webpack_public_path__ + "img/douyin-coupon-vertify-icon.4d2f8938.png";